import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import Navigation from './components/Navigation';
import NotificationProvider from './components/NotificationProvider';
import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import CaseStudies from './pages/CaseStudies';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import VerifyOTP from './pages/VerifyOTP';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Services from './pages/Services';
import ServiceDetails from './pages/ServiceDetails';
import AdvertisingService from './pages/AdvertisingService';
import Notifications from './pages/Notifications';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navigation 
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        {session && <NotificationProvider />}
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route
              path="/signup"
              element={!session ? <SignUp /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/login"
              element={!session ? <Login /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/forgot-password"
              element={!session ? <ForgotPassword /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/verify-otp"
              element={!session ? <VerifyOTP /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/reset-password"
              element={!session ? <ResetPassword /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/dashboard"
              element={session ? <Dashboard activeTab={activeTab} /> : <Navigate to="/login" />}
            />
            <Route
              path="/services"
              element={session ? <Services /> : <Navigate to="/login" />}
            />
            <Route
              path="/services/:serviceId"
              element={session ? <ServiceDetails /> : <Navigate to="/login" />}
            />
            <Route
              path="/services/advertising"
              element={<AdvertisingService />}
            />
            <Route
              path="/notifications"
              element={session ? <Notifications /> : <Navigate to="/login" />}
            />
            <Route
              path="/support"
              element={session ? <Support /> : <Navigate to="/login" />}
            />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;